import React, {useEffect, useRef, useState} from 'react';

import Constants from '../../common/Constants';
import ErrorHandler from '../../common/errors/ErrorHandler';
import MetricsService from '../../common/services/MetricsService';
import {Domain, findSiteByDomain, Stage, SiteProvider} from "@zooplus/commons-lang";
import {PDPProduct} from "../model/BonusPointsProduct";
import {getLocale} from "../../common/utils/locale";
import {LocResourcesProvider} from "../../common/contexts/LocResourcesContext";
import keys from "../locResourcesKeys";
import PDPProductUpperInfo from "./product-upper-info/PDPUpperInfo";
import PDPProductDetails from "./product-details/PDPProductDetails";
import {ViewType} from "../model/ViewType";
import {CartProvider} from "@zooplus/cart-provider";
import {initializeI18n} from "../../common/services/i18n-service";
import {I18nextProvider} from "react-i18next";

interface PDPProductDetailsProps {
  siteDomain: Domain;
  product: PDPProduct;
  mediaServerUrl: string;
  reviewNumberTranslation: string;
  redeemableBalance: number;
  selection: number[];
  environment: Stage;
  view: ViewType;
}

const PDP: React.FC<PDPProductDetailsProps> = ({
  siteDomain,
  product,
  mediaServerUrl,
  reviewNumberTranslation,
  redeemableBalance,
  selection,
  environment,
  view
}: PDPProductDetailsProps) => {
  const [detailsLoaded, setDetailsLoaded] = useState<boolean>();
  const [upperInfoLoaded, setUpperInfoLoaded] = useState<boolean>();
  const metricServiceInstanceRef = useRef<MetricsService>(
    MetricsService.init(Constants.COMPONENT_NAME.PDP, Constants.COMPONENT_LOCATION.PDP, siteDomain)
  );

  useEffect(() => {
    if (detailsLoaded && upperInfoLoaded) {
      metricServiceInstanceRef.current.renderSuccess();
    }
  }, [detailsLoaded, upperInfoLoaded]);

  const site = findSiteByDomain(siteDomain);

  return <ErrorHandler metricsService={metricServiceInstanceRef.current}>
    <LocResourcesProvider
      metricsService={metricServiceInstanceRef.current}
      locale={getLocale(site)}
      keys={keys}
      siteId={site.id}>
      <SiteProvider site={site} locale={site.locale}>
        <I18nextProvider i18n={initializeI18n(site.locale)}>
          <CartProvider stage={environment}>
            <div style={{ gridColumn: "1 / -1", marginTop: "40px" }}>
              <PDPProductUpperInfo product={product}
                                   mediaServerUrl={mediaServerUrl}
                                   redeemableBalance={redeemableBalance}
                                   selection={selection}
                                   reviewNumberTranslation={reviewNumberTranslation}
                                   view={view}
                                   onRenderSuccess={() => setUpperInfoLoaded(true)}/>
              <PDPProductDetails product={product}
                                 mediaServerUrl={mediaServerUrl}
                                 onRenderSuccess={() => setDetailsLoaded(true)}/>
            </div>
          </CartProvider>
        </I18nextProvider>
      </SiteProvider>
    </LocResourcesProvider>
    </ErrorHandler>;
};

export default React.memo(PDP);
